import { WindowTitle } from "@saleor/components/WindowTitle";
import CustomerMaterialView from "@saleor/customerMaterial/views";
import { sectionNames } from "@saleor/intl";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router";

import { customerMaterialUrl } from "./urls";

const CustomerMaterialSection = () => {
  const intl = useIntl();

  const CustomerMaterialComponent: React.FC<RouteComponentProps<any>> = () => (
    <CustomerMaterialView />
  );

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.customerMaterial)} />
      <Switch>
        <Route
          exact
          path={customerMaterialUrl}
          render={CustomerMaterialComponent}
        />
      </Switch>
    </>
  );
};

export default CustomerMaterialSection;
